__turbopack_context__.v({
  "semester-date": "styles-module__7OxjAq__semester-date",
});
